<template>
  <div class="wallet_head">

    <div-height height='13vw' />

    <div class="header">

      <div class="left">
        <div class="account" @click="toggleWalletConnection">
          <p class="one" v-if="$store.getters.isLoggedIn">{{ formatAddress(account) }}</p>
          <p class="one" v-else>链接钱包</p>
        </div>
      </div>

      <div class="center">
        <div v-if="show_type == 1">
          <div class="title_logo">
            <img src="@/assets/img/logo.png">
          </div>
        </div>
        <div v-if="show_type == 2">{{ $t('钱包') }}</div>
        <div v-if="show_type == 3">{{ $t('行情') }}</div>
        <div v-if="show_type == 4">{{ $t('邀请好友') }}</div>
        <div v-if="show_type == 5">{{ $t('我的团队') }}</div>
        <div v-if="show_type == 6">{{ $t('交易规则') }}</div>
        <div v-if="show_type == 7">{{ $t('关于我们') }}</div>
        <div v-if="show_type == 8">{{ $t('公告列表') }}</div>
      </div>

      <div class="right">

        <div @click="show_left = true" class="lang_icon">
          <img v-if="getLang() == 'zh'" src="@/assets/img/diqiu.png">
          <img v-if="getLang() == 'en'" src="@/assets/img/diqiu.png">
          <img v-if="getLang() == 'tw'" src="@/assets/img/diqiu.png">
        </div>

        <div class="menu_icon" @click="show = true" v-if="$store.getters.isLoggedIn">
          <img src="@/assets/img/menu.png">
        </div>

      </div>
    </div>

    <van-popup v-model="show_left" position="left" :style="{ width: '55%', height: '100%' }">
      <div class="navbox">

        <div class="top_bj">
          <div class="address_left">
            <div class="img">
              <img src="@/assets/img/close.png" @click="show_left = false">
            </div>
          </div>
          <div class="heard_bottom">

            <div class="xinxi">
              <div-img width='18vw' height='18vw' radius="50%" margin="0">
                <img src="@/assets/img/langx.png">
              </div-img>
            </div>

            <div class="dizhi">
              <p class="one">{{ $t('请选择语言') }}</p>
            </div>
          </div>
        </div>

        <div class="caidan">

          <a :class="{ 'active': getLang() == 'zh' }" @click="changeLang('zh'); show_left = false">
            <img src="@/assets/img/zh.png">
            <div class="icon"></div>
            <p class="one">简体中文</p>
          </a>

          <a :class="{ 'active': getLang() == 'en' }" @click="changeLang('en'); show_left = false">
            <img src="@/assets/img/en.png">
            <div class="icon"></div>
            <p class="one">English</p>
          </a>

          <a :class="{ 'active': getLang() == 'tw' }" @click="changeLang('tw'); show_left = false">
            <img src="@/assets/img/tw.png">
            <div class="icon"></div>
            <p class="one">繁體中文</p>
          </a>

        </div>
      </div>
    </van-popup>

    <van-popup v-model="show" position="right" :style="{ width: '55%', height: '100%' }">
      <div class="navbox">

        <div class="top_bj">
          <div class="address">

            <div class="img">
              <img src="@/assets/img/close.png" @click="show = false">
            </div>
          </div>
          <div class="heard_bottom">

            <div class="xinxi">
              <div-img width='18vw' height='18vw' radius="50%" margin="0">
                <img src="@/assets/img/logo.png">
              </div-img>
            </div>

            <div class="dizhi" @click="copyData(account)">
              <p v-if="account" class="one">{{ $t('我的钱包') }} ：{{ account }}</p>
            </div>
          </div>
        </div>

        <div class="caidan">

          <router-link :class="{ 'active': active_name == '/' }" to="/">

            <img src="../assets/img/a01.png">
            <div class="icon"></div>
            <p class="one">{{ $t('首页') }}</p>

          </router-link>

          <router-link :class="{ 'active': active_name == '/qianbao' }" to="qianbao">

            <img src="../assets/img/a02.png">
            <div class="icon"></div>
            <p class="one">{{ $t('钱包') }}</p>

          </router-link>

          <router-link :class="{ 'active': active_name == '/hangqing' }" to="hangqing">

            <img src="../assets/img/a03.png">
            <div class="icon"></div>
            <p class="one">{{ $t('行情') }}</p>

          </router-link>

          <router-link :class="{ 'active': active_name == '/share' }" to="share">

            <img src="../assets/img/a07.png">
            <div class="icon"></div>
            <p class="one">{{ $t('邀请好友') }}</p>

          </router-link>


          <router-link :class="{ 'active': active_name == '/wodeshequn' }" to="wodeshequn">

            <img src="../assets/img/a10.png">
            <div class="icon"></div>
            <p class="one">{{ $t('我的团队') }}</p>

          </router-link>

          <router-link :class="{ 'active': active_name == '/html01' }" to="html01">

            <img src="../assets/img/a08.png">
            <div class="icon"></div>
            <p class="one">{{ $t('交易规则') }}</p>

          </router-link>


          <router-link :class="{ 'active': active_name == '/html02' }" to="html02">

            <img src="../assets/img/a05.png">
            <div class="icon"></div>
            <p class="one">{{ $t('关于我们') }}</p>

          </router-link>


          <router-link :class="{ 'active': active_name == '/new' }" to="new">

            <img src="../assets/img/a04.png">
            <div class="icon"></div>
            <p class="one">{{ $t('公告中心') }}</p>

          </router-link>

        </div>
      </div>
    </van-popup>

  </div>
</template>
<script>
import Web3 from "web3"
export default {
  props: {
    show_type: {
      type: String,
      default: "1",
    },
    // address: {
    //   type: String,
    //   default: ""
    // },
  },
  data() {
    return {
      show: false,
      show_left: false,
      account: "",
      isConnected: false,
    }
  },
  computed: {
    active_name() {
      return this.$route.path;
    },
  },

  created() {
    // 初始化数据
    this.restoreAuthState();
  },
  methods: {
    restoreAuthState() {
      console.log('restoreAuthState');
      const token = this.local.get('token');
      const account = this.local.get('account') || '';

      console.log('token', token, account);

      if (token && account) {

        this.account = account;
        this.$store.commit('SET_TOKEN', token)
        this.$store.commit('SET_WALLET_ACCOUNT', account)
      } else {
        console.log('no token');
        console.log('account', account);



        this.account = '';
        this.$store.commit('REMOVE_TOKEN')
        this.$store.commit('SET_WALLET_ACCOUNT', '')

        this.FirstConnectAndLogin();

      }

    },
    // 主入口：点击钱包区域触发
    async toggleWalletConnection() {
      if (this.$store.getters.isLoggedIn) {
        // 已连接 → 退出
        await this.disconnectWallet();
      } else {
        // 未连接 → 连接 + 登录
        await this.FirstConnectAndLogin();
      }
    },

    // 连接钱包 + 签名登录
    async FirstConnectAndLogin() {
      if (!window.ethereum) {
        this.$toast(this.$t("请安装钱包插件"));
        return;
      }

      const web3 = new Web3(window.ethereum);

      // 1. 先确保在 BSC 测试网
      try {
        const chainId = await web3.eth.getChainId();
        if (chainId !== 56) {
          await window.ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: '0x38' }]
          });
          // ⚠️ 链切换成功后，**必须重新创建 web3 实例（可选但推荐）**
          // 因为 provider 状态已变
          web3.setProvider(window.ethereum);
        }
      } catch (err) {
        console.error("切换链失败", err);
        this.$toast(this.$t("请手动切换到币安链"));
        return;
      }

      // 2. ✅ 关键：链切换后，重新请求账户（即使之前连过）
      let accounts;
      try {
        accounts = await window.ethereum.request({ method: "eth_requestAccounts" });
      } catch (err) {
        this.$toast(this.$t("用户取消连接"));
        return;
      }

      const account = accounts[0];

      console.log('最新account', account);

      // 4. 判断是否需要弹窗
      const has = await this.$post_pr({
        url: "/api/v1/member/has",
        noToken: true,
        data: {
          account: account
        }
      });

      console.log('has', has.data.has);


      if (has.data.has) {
        // // 3. 签名 + 登录
        const message = this.getGuid();
        let signature;
        try {
          signature = await web3.eth.personal.sign(message, account);
        } catch (err) {
          this.$toast(this.$t("签名被取消"));
          return;
        }

        // 4. 调登录接口
        this.$post({
          url: "/api/v1/login",
          noToken: true,
          data: {
            account,
            msg: message,
            sign: signature,
            invite_code: this.$route.query.invite_code
          },
          success: (res) => {
            this.local.set("token", res.data.token);
            // 👇 必须这一步！
            this.$store.commit('SET_TOKEN', res.data.token)

            this.get_info(); // 拉取用户信息
          },
          tip: () => {
            this.local.del("token");
          },

        });
      } else {
        console.log('没有用户');

        if (this.$route.query.invite_code) {
          const confirm = await this.$dialog.confirm({
            message: this.$t('您要绑定的邀请码') + this.$route.query.invite_code,
          }).catch(() => { });

          if (!confirm) return;

          // // 3. 签名 + 登录
          const message = this.getGuid();
          let signature;
          try {
            signature = await web3.eth.personal.sign(message, account);
          } catch (err) {
            this.$toast(this.$t("签名被取消"));
            return;
          }

          // 4. 调登录接口
          this.$post({
            url: "/api/v1/login",
            noToken: true,
            data: {
              account,
              msg: message,
              sign: signature,
              invite_code: this.$route.query.invite_code
            },
            success: (res) => {
              this.local.set("token", res.data.token);
              // 👇 必须这一步！
              this.$store.commit('SET_TOKEN', res.data.token)

              this.get_info(); // 拉取用户信息
            },
            tip: () => {
              this.local.del("token");
            },

          });


        } else {
          const confirm = await this.$dialog.confirm({
            message: this.$t('您需要有绑定的邀请码'),
          }).catch(() => { });
        }




      }


    },

    // 连接钱包 + 签名登录
    async connectAndLogin() {
      if (!window.ethereum) {
        this.$toast(this.$t("请安装钱包插件"));
        return;
      }

      const web3 = new Web3(window.ethereum);

      // 1. 先确保在 BSC 测试网
      try {
        const chainId = await web3.eth.getChainId();
        if (chainId !== 56) {
          await window.ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: '0x38' }]
          });
          // ⚠️ 链切换成功后，**必须重新创建 web3 实例（可选但推荐）**
          // 因为 provider 状态已变
          web3.setProvider(window.ethereum);
        }
      } catch (err) {
        console.error("切换链失败", err);
        this.$toast(this.$t("请手动切换到币安链"));
        return;
      }

      // 2. ✅ 关键：链切换后，重新请求账户（即使之前连过）
      let accounts;
      try {
        accounts = await window.ethereum.request({ method: "eth_requestAccounts" });
      } catch (err) {
        this.$toast(this.$t("用户取消连接"));
        return;
      }

      const account = accounts[0];

      // 3. 签名 + 登录
      const message = this.getGuid();
      let signature;
      try {
        signature = await web3.eth.personal.sign(message, account);
      } catch (err) {
        this.$toast(this.$t("签名被取消"));
        return;
      }

      // 4. 调登录接口
      this.$post({
        url: "/api/v1/login",
        noToken: true,
        data: {
          account,
          msg: message,
          sign: signature,
          invite_code: this.$route.query.invite_code
        },
        success: (res) => {
          this.local.set("token", res.data.token);
          // 👇 必须这一步！
          this.$store.commit('SET_TOKEN', res.data.token)

          this.get_info(); // 拉取用户信息
        },
        tip: () => {
          this.local.del("token");
        },

      });
    },
    // 退出钱包连接
    async disconnectWallet() {
      const confirm = await this.$dialog.confirm({
        message: this.$t('确定要退出吗') + "?",
      }).catch(() => { });

      if (!confirm) return;

      // 清除登录状态
      this.local.del("token");
      this.local.del("account");

      this.$store.commit('RESET_WALLET')


      this.restoreAuthState()


    },
    // 获取用户信息（含 account）
    async get_info() {

      this.$get({
        url: "/api/v1/member/getMemberInfo",
        success: (res) => {
          // this.info = res.data || {};
          // 保存到 sessionStorage
          console.log("保存用户信息", res.data);
          this.local.set('account', res.data.account);

          this.restoreAuthState(); // 立即更新 UI
          this.initWeb3AndContract();

        },
        tip: () => {
          this.local.del("token");
        },
      });
    },

    // 工具：生成唯一消息（用于签名）
    getGuid() {
      return "Login to App at " + new Date().toISOString();
    },

    // 工具：格式化地址
    formatAddress(addr) {
      if (!addr) return "";
      return addr.length > 10
        ? addr.substring(0, 6) + "..." + addr.substring(addr.length - 4)
        : addr;
    },

    // App.vue 或全局 utils
    initWeb3AndContract() {
      let self = this;
      this.$nextTick(() => {
        self.$metaMask.init().then(() => {
          let web3 = self.$metaMask.getWeb3();
          self.$metaMask.getContract(web3, self.$abi);
        });
      })
    }




  }
}
</script>
<style lang='less' scoped>
.header {
  width: 100%;
  background: #141629;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  position: fixed;
  top: 0;
  z-index: 99;

  .title_logo {
    width: 10vw;
    height: 10vw;

    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  .left {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100px;

    .account {
      width: 100px;
      height: 30px;
      // padding: 3vw;
      // background: rgba(56, 48, 36, 0.51);
      border-radius: 15px;
      display: flex;
      // justify-content: center;
      align-items: center;

      p {
        font-size: 12px;
        color: #fff;
      }
    }

    .a {
      width: 30px;
      height: 30px;
      margin-left: 10px;
    }
  }

  .right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100px;

    .lang_icon {
      width: 22px;
      height: 22px;


      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }

    .menu_icon {
      width: 22px;
      height: 22px;
      margin-left: 5vw;

      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }

    // img {
    //   width: 22px;
    //   height: 22px;

    // }

    font-size: 20px;
    font-weight: 550;
  }


}



/deep/.van-overlay {
  background-color: rgba(0, 0, 0, 0.2) !important;
}

/deep/.van-popup {
  width: 100%;
  background-color: rgba(39, 44, 82, 1);

  .navbox {
    width: 100%;
    padding-bottom: 30px;
    display: flex;
    flex-direction: column;

    .top_bj {
      padding: 0 15px 20px;


      .address {
        width: 100%;
        padding: 20px 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 0;



        .img {
          width: 20px;
          height: 20px;
          margin-right: 20px;

          img {
            width: 100%;
            height: 100%;
            display: block;
          }
        }
      }

      .address_left {
        width: 100%;
        padding: 20px 0;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 0;

        .img {
          width: 20px;
          height: 20px;

          img {
            width: 100%;
            height: 100%;
            display: block;
          }
        }

      }

      .heard_bottom {
        .xinxi {
          display: flex;

          justify-content: center;

          img {
            width: 18vw;
            height: 18vw;
          }


        }

        .dizhi {
          border-radius: 2vw;
          padding: 1vw 3vw;
          margin-top: 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          text-align: center;

          p {
            flex: 1;
            font-size: 4vw;
            font-weight: 550;
            color: #fff;
          }

          img {
            width: 4vw;
            height: 4vw;
          }
        }
      }
    }

    .caidan {
      >a {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 3vw 4vw;

        img {
          width: 18px;
          height: 18px;
          object-fit: contain;
        }

        p {
          flex: 1;
          padding: 0 15px 0 7px;
          color: #ffffff;
          font-size: 16px;
          font-weight: 600;
        }

        span {
          width: 4vw;
          height: 4vw;

          img {
            width: 100%;
            height: 100%;
            display: block;
          }
        }
      }

      .active {
        background: #101221;

        p {
          color: #fff !important;
        }
      }
    }
  }
}
</style>
